/* eslint space-before-function-paren: 0 */
/* eslint no-undef: 0 */
class IframeClickToPlay {
    /**
     * Create new iframe click to play instance
     * @param {Object} options Options
     * @param {HTMLElement} options.iframe Target iframe
     * @param {HTMLElement} options.fallback Fallback content
     * @param {HTMLButtonElement} options.trigger Click-to-play trigger
     */
    constructor({ iframe, fallback, trigger }) {
        this.container = iframe
        this.iframe = iframe
        this.src = iframe.dataset.src
        this.fallback = fallback
        this.trigger = trigger
        this.placeholder = document.createComment('')

        if (iframe.tagName !== 'IFRAME') {
            const descendant = iframe.querySelector('iframe')
            this.iframe = descendant
            this.src = descendant.src
        }
    }

    init() {
        if (!Cookiebot.consent.marketing) {
        // Remove the iframe from the DOM to avoid a history entry on src change.
            this.container.after(this.placeholder)
            this.container.remove()
            this.fallback.style.display = 'grid'

            this.trigger.addEventListener('click', () => {
                this.setCookieConsent()
                this.play()
            })
        } else {
            this.play()
        }
    }

    setCookieConsent() {
        Cookiebot.submitCustomConsent(Cookiebot.consent.preferences, Cookiebot.consent.statistics, true)
    }

    play() {
        this.iframe.src = this.src
        this.placeholder.replaceWith(this.container)

        this.fallback.remove()
        this.trigger.remove()
    }
}

export { IframeClickToPlay }
